const RenewSubscriptionHistory = ({ data, title }) => {
  return (
    <section className="tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md">
      <h3 className="tw-text-xl tw-font-semibold tw-text-primary tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div className="tw-overflow-x-auto">
        {data?.length > 0 ? (
          <table className="tw-min-w-full tw-bg-white tw-rounded-lg tw-shadow-md">
            <thead>
              <tr className="tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-whitespace-nowrap">
                <th className="tw-px-4 tw-py-2 ">Renew Duration</th>
                <th className="tw-px-4 tw-py-2">Renew Subscription Date</th>
                <th className="tw-px-4 tw-py-2">Old Expiration Date</th>
                <th className="tw-px-4 tw-py-2">New Expiration Date</th>
                <th className="tw-px-4 tw-py-2">Notes</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((d, index) => (
                <tr key={index} className="tw-border-b tw-border-gray-200">
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-gray-900">
                    {d.renewDuration}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {d.renewSubscriptionDate}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {d.oldExpirationDate}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {d.newExpirationDate}
                  </td>
                  <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                    {d.notes}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="!tw-text-center tw-mx-auto">"No records found."</p>
        )}
      </div>
    </section>
  );
};

export default RenewSubscriptionHistory;
